import { Component } from '@angular/core';

@Component({
  selector: 'app-dashboard-loader',
  templateUrl: './dashboard-loader.component.html',
})
export class DashboardLoaderComponent {}
